<template>
    <div class="input-group">
        <span v-if="showIcon === undefined || showIcon" class="input-group-text">
            <svg :width="iconSize" :height="iconSize" fill="currentColor">
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
        </span>
        <textarea
            class="form-control"
            :placeholder="placeholder"
            autocomplete="off"
            @input="$emit('update:modelValue', $event.target.value)"
            @keyup="$emit('keyup')"
            @blur="$emit('blur')"
            @change="$emit('onChange', $event)"
        ></textarea>
    </div>
</template>


<script>
    export default {
        name: 'TextareaField',
        props: {
            showIcon: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: String,
                default: "info",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
            placeholder: {
                type: String,
                default: "",
            },
        },
        setup() {},
    };
</script>